export const SET_JACKPOT_TICKER = 'CASINO.SET_JACKPOT_TICKER';
export const UPDATE_JACKPOT_TICKER = 'CASINO.UPDATE_JACKPOT_TICKER';
export const REMOVE_JACKPOT_TICKERS = 'CASINO.REMOVE_JACKPOT_TICKERS';
export const SET_LIVECASINO_TICKER = 'CASINO.SET_LIVECASINO_TICKER';
export const UPDATE_LIVECASINO_TICKER = 'CASINO.UPDATE_LIVECASINO_TICKER';
export const REMOVE_LIVECASINO_TICKERS = 'CASINO.REMOVE_LIVECASINO_TICKERS';
export const SET_BACCARAT_TICKER = 'CASINO.SET_BACCARAT_TICKER';
export const REMOVE_BACCARAT_TICKERS = 'CASINO.REMOVE_BACCARAT_TICKERS';
